import { useState } from "react"
import notification from "./notif.png"
import { NotificationMenu, OutSideClickHandler } from "components"
import { Box } from "theme-ui"

// interface of notification array
interface notificationStructure {
 id: number
 date: string
 user_name: string
 user_message: string
}

// notification array declaration
const Notifications: notificationStructure[] = [
 {
  id: 1,
  date: "24 Jan, 2023",
  user_name: "Aktionenlog",
  user_message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
 },
 {
  id: 2,
  date: "24 Jan, 2023",
  user_name: "Aktionenlog",
  user_message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
 },
 {
  id: 3,
  date: "24 Jan, 2023",
  user_name: "Aktionenlog",
  user_message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
 },
]
export const Notification: React.FC = () => {
 // notificationMenu state is for opening and closing of notification
 const [notificationMenu, setNotificationMenu] = useState<boolean>(false)

 // state for storing notification data
 const [notificationData, setNotificationData] = useState(() => {
  return Notifications
 })
 // method that close the Notification Menu on outside click
 const outSideClickHandler = () => {
  setTimeout(() => {
   setNotificationMenu(false)
  }, 300)
 }

 // method for deleting notification
 const deleteNotification = (id: number) => {
  const afterDelete = notificationData.filter((single) => single.id !== id)
  setNotificationData(afterDelete)
 }

 return (
  <div className="relative">
   {/* =========== toggle-method is calling on button click */}
   <button
    onClick={() => setNotificationMenu(!notificationMenu)}
    className="border rounded-lg flex items-center justify-center p-1 lg:p-3"
   >
    <Box className="relative">
     {/* notification-svg */}
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
     >
      <path
       d="M12.0186 2.91016C8.70862 2.91016 6.01862 5.60016 6.01862 8.91016V11.8002C6.01862 12.4102 5.75862 13.3402 5.44862 13.8602L4.29862 15.7702C3.58862 16.9502 4.07862 18.2602 5.37862 18.7002C9.68862 20.1402 14.3386 20.1402 18.6486 18.7002C19.8586 18.3002 20.3886 16.8702 19.7286 15.7702L18.5786 13.8602C18.2786 13.3402 18.0186 12.4102 18.0186 11.8002V8.91016C18.0186 5.61016 15.3186 2.91016 12.0186 2.91016Z"
       stroke="#0D0D0D"
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
      />
      <path
       d="M13.8719 3.19994C13.5619 3.10994 13.2419 3.03994 12.9119 2.99994C11.9519 2.87994 11.0319 2.94994 10.1719 3.19994C10.4619 2.45994 11.1819 1.93994 12.0219 1.93994C12.8619 1.93994 13.5819 2.45994 13.8719 3.19994Z"
       stroke="#0D0D0D"
       strokeWidth="1.5"
       strokeMiterlimit="10"
       strokeLinecap="round"
       strokeLinejoin="round"
      />
      <path
       d="M15.0195 19.0601C15.0195 20.7101 13.6695 22.0601 12.0195 22.0601C11.1995 22.0601 10.4395 21.7201 9.89953 21.1801C9.35953 20.6401 9.01953 19.8801 9.01953 19.0601"
       stroke="#0D0D0D"
       strokeWidth="1.5"
       strokeMiterlimit="10"
      />
     </svg>
     {notificationData.length === 0 ? (
      ""
     ) : (
      <div className="w-2 absolute top-0 right-0">
       <img src={notification} alt="" />
      </div>
     )}
    </Box>
   </button>
   <div className="absolute z-40 lg:right-0 right-[-100px] top-20">
    {/* NotificationMenu is opening and closing on state true or false */}
    {notificationMenu && (
     <OutSideClickHandler callback={outSideClickHandler}>
      <NotificationMenu
       deleteNotification={deleteNotification}
       notificationData={notificationData}
      />
     </OutSideClickHandler>
    )}
   </div>
  </div>
 )
}
